(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.createResponsiveOwlGallery = {
    attach: function (context, settings) {
      $(once('gallery-carousel','.gallery-main',context)).each(function(key, item) {
        // Create unique identifiers for each carousel.
        var sliderIdName = 'slider' + key;
        var sliderNavIdName = 'sliderNav' + key;
        var sliderControlsIdName = 'sliderControls' + key;
        var sliderId = '#' + sliderIdName;
        var sliderNavId = '#' + sliderNavIdName;
        var sliderControlsId = '#' + sliderControlsIdName;

        // Add unique identifier to the carousel main, nav and controls.
        this.id = sliderIdName;
        $(this).parent().find(".gallery-nav")[0].id = sliderNavIdName;
        $(this).parent().find(".gallery-controls")[0].id = sliderControlsIdName;

        // Move first item to end inside sliderNavId.
        var firstItem = $(sliderNavId + ' > *:first-child');
        firstItem.appendTo($(sliderNavId));

        // Provide empty array fallback.
        const navTypeElement = $(this).attr("data-navcount") || [];

        // Using optional chaining.
        const navTypeElementLength = navTypeElement?.length;
        var navTypeCount = 0;

        // Apply logic only if we have a nav element on the carousel.
        if (navTypeElementLength > 0) {
          // To read in the navcount and configure the carousel accordingly.
          navTypeCount = navTypeElement.substr(-1);
        }

        if (navTypeCount > 0) {
          $(sliderId).slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            appendArrows: sliderControlsId,
            appendDots: sliderControlsId,
            asNavFor: sliderNavId
          });

          $(sliderNavId).slick({
            asNavFor: sliderId,
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: navTypeCount,
            slidesToScroll: 1,
            vertical: true,
            draggable: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: "unslick",
              },
            ],
          });
        }
        else {
          // If the carousel has no-nav settings, remove the nav.
          $(this).parent().find(".gallery-nav").remove();
          $(sliderId).slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            appendArrows: sliderControlsId,
            appendDots: sliderControlsId
          });
        }

        // Advance from main.
          $(sliderId).on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              $(sliderNavId).slick("slickGoTo", nextSlide + 1);
            }
          );
        });
    },
  };
})(jQuery, Drupal, drupalSettings);
